import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutEdiProfileBillingQuickInfo } from "./autogen/AutogenLayoutEdiProfileBillingQuickInfo";
import { EdiUtility } from "./EdiUtility";
import { BillingProfile } from "./BillingProfile";

export class EdiProfileBillingQuickInfo extends AutogenLayoutEdiProfileBillingQuickInfo {
    doAfterExecute(event: DataSourceExecutionEvent) {
        if (StringUtil.isEmptyString(this.sourceEdibillingProfile.activeRow?.get("notes"))) {
            this.imagePartnerNotes.enabled = false;
            this.imagePartnerNotes.imageColor = "subtle.light";
            this.imagePartnerNotes.tooltip = "No partner notes available"
        }
    }

    openClassicPartnerProfile(event: ClickEvent): void {
        const id = this.sourceEdibillingProfile?.activeRow?.get("id");
        if (id != null) {
            BillingProfile.navigateTo(id);
        }
    }

    showPartnerNotes() {
        EdiUtility.showPartnerNotes(this.sourceEdibillingProfile.activeRow?.get("id"),
            this.sourceEdibillingProfile.activeRow?.get("partner_name"), this.sourceEdibillingProfile.activeRow?.get("notes"));
    }
}